import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { fetch } from 'actions/EmployeeHoliday';

import { getSettingByKey } from 'utils/localSettings';
import { FormattedMessage } from 'react-intl';
import pallet from 'constants/colors';

import KValue from 'components/KJRN/KValue';
import KTitle from 'components/KJRN/KTitle';
import KFlatButton from 'components/KJRN/KFlatButton';

import { Divider } from 'material-ui';

import TLoading from './TLoading';
import TMessage from './TMessage';

const styles = {
  container: {
    width: 'calc(100% - 72px)',
    height: 'calc(100% - 36px)',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 26,
    paddingBottom: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  action: {
    flex: '1 1 0',
    justifyContent: 'center',
    minHeight: 40,
    maxHeight: 40,
  },
  actionButton: {
    maxWidth: 'none',
    fontSize: 14,
  },
  chart: {
    width: 'calc(100% - 2px)',
    height: 24,
    borderRadius: 4,
    overflow: 'hidden',
    marginTop: 12,
    marginBottom: 12,
    backgroundColor: '#eeeeee',
  },
  chartBar: {
    height: '100%',
    backgroundColor: pallet.primary3Color,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    justifyContent: 'space-around',
  },
  row: {
    display: 'flex',
  },
  title: {
    fontSize: 18,
    fontWeight: 'normal',
    marginLeft: 0,
  },
  spacer: {
    marginTop: 30,
  },
  mainValue: {
    fontSize: 24,
  },
};


class THoliday extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showByHour: getSettingByKey('showHolidayByHour') || false };
  }

  componentDidMount() {
    this.props.fetch();
  }

  render() {
    const {
      loaded,
      hasError,
      holidays,
    } = this.props;

    if (!loaded) {
      return <TLoading />;
    }

    if (hasError) {
      return <TMessage type="error" message="tile.holiday.error" />;
    }

    if (!holidays || !holidays.length) {
      return <TMessage message="tile.holiday.empty" />;
    }

    const {
      FirstOfMai,
      Sum,
      PayWageCollectYear,
      WorkTimePerDay,
      // Earned,
      Taken,
      // Settlement,
    } = holidays[0];

    let left = 0;
    if (FirstOfMai > Taken) {
      left = (1 - (Taken / FirstOfMai)) * 100;
    }

    let divider = WorkTimePerDay;
    let formatId = 'holiday.days';
    if (this.state.showByHour) {
      divider = 1;
      formatId = 'holiday.hours';
    }

    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <KTitle
            containerStyle={{ marginBottom: 8 }}
            style={styles.title}
            subtitleStyle={{ marginLeft: 0 }}
            title={<FormattedMessage id="holiday.title.year" values={{ year: PayWageCollectYear }} />}
            subtitle={<FormattedMessage
              id="tile.holiday.period"
              values={{ year: PayWageCollectYear, nextYear: PayWageCollectYear + 1 }}
            />}
          />
          <div style={styles.row}>
            <KValue
              valueStyle={styles.mainValue}
              value={
                <FormattedMessage
                  id={formatId}
                  values={{ val: (Sum / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                />
              }
              label={<FormattedMessage id="tile.holiday.sum" />}
            />
          </div>
          <div style={styles.chart}>
            <div style={{ ...styles.chartBar, width: `${left}%` }} />
          </div>
          <div style={styles.row}>
            <KValue
              value={
                <FormattedMessage
                  id={formatId}
                  values={{ val: (FirstOfMai / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                />
              }
              label={
                <FormattedMessage id="tile.holiday.firstOfMay" values={{ year: PayWageCollectYear }} />
              }
            />
            <KValue
              value={
                <FormattedMessage
                  id={formatId}
                  values={{ val: (Taken / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                />
              }
              label={
                <FormattedMessage id="tile.holiday.taken" values={{ year: PayWageCollectYear }} />
              }
            />
          </div>
        </div>
        <Divider key="div" style={styles.spacer} />
        <KFlatButton
          style={styles.actionButton}
          onClick={() => this.context.router.push('/holiday')}
          containerStyle={styles.action}
          label={<FormattedMessage id="tile.holiday.goto" />}
        />
      </div>
    );
  }
}

THoliday.propTypes = {
  loaded: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  fetch: PropTypes.func.isRequired,
  holidays: PropTypes.array.isRequired,
};

THoliday.contextTypes = {
  router: PropTypes.object.isRequired,
};


export default connect(
  ({ EmployeeHolidayReducer }) => ({ ...EmployeeHolidayReducer }),
  dispatch => ({ fetch: () => dispatch(fetch()) }),
)(THoliday);



// WEBPACK FOOTER //
// ./src/containers/tiles/THoliday.js